// Media Gallery: Handle thumbnail clicks and update main image
function updateMainImage(thumbnail) {
  document
    .querySelectorAll(".mh-thumbnail")
    .forEach((thumb) => thumb.classList.remove("active-thumb"));
  thumbnail.classList.add("active-thumb");
  const newImageSrc = thumbnail.getAttribute("data-img-src");
  const mainImage = document.querySelector(".mh-main-image img");
  mainImage.src = newImageSrc;
  mainImage.srcset = newImageSrc;
}

// Initiate functions on DOM content load
document.addEventListener("DOMContentLoaded", function () {
  moveTabs();
  moveSubTabs();
  fileInput();
  // REMOVED: checkboxGroup(); - This was preventing multiple selections
  stepOneValidate();
  stepTwoValidate();
  stepThreeValidate(); // Added this - it was missing!
});

// Move Subtabs: Handle clicks on subtab buttons to switch tabs
function moveSubTabs() {
  const buttons = document.querySelectorAll(".mh-tab-btn-d5");
  const dynamicSettings = document.querySelector(".dynamic-settings-d5");

  buttons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Getting the closest parent container of the clicked button
      const parentContainer = button.closest(".mh-steps-container");

      if (button.classList.contains("next-btn-d5") && parentContainer.classList.contains("form-error-d5")) {
        console.log("Form error present in current step, cannot proceed.");
        button.parentElement.classList.add('show-error-d5');
        setTimeout(() => {
          button.parentElement.classList.remove('show-error-d5');
        }, 3000);
        return; // Stop the function if there's an error in the current step
      }

      // Move to next or previous tab if no errors (or if it's a back button)
      const classToAdd = button.getAttribute("data-class-d5");
      clearActiveClasses(dynamicSettings, "current");
      dynamicSettings.classList.add(classToAdd);
    });
  });
}

// Move Tabs: Handle clicks on main tab buttons to switch tabs
function moveTabs() {
  const buttons = document.querySelectorAll(".mh-move-btn-d5");
  const dynamicSettings = document.querySelector(".dynamic-settings-d5");

  buttons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const classToAdd = button.getAttribute("data-class-d5");
      clearActiveClasses(dynamicSettings, "active");
      dynamicSettings.classList.add(classToAdd, "current-step-1");
    });
  });
}

// Helper function to clear active classes based on a given prefix
function clearActiveClasses(element, prefix) {
  element.classList.forEach((className) => {
    if (className.startsWith(prefix)) {
      element.classList.remove(className);
    }
  });
}

// Update the quantity input
function updatePreQuantity() {
  const radioInputs = document.querySelectorAll(
    '.pre-qty-input-d5[type="radio"]'
  );
  const customInput = document.querySelector(".custom-qty-d5 input");

  radioInputs.forEach(function (input) {
    input.addEventListener("change", function () {
      radioInputs.forEach((input) =>
        input.parentElement.classList.remove("active")
      );
      customInput.value = "";
      if (this.checked) {
        this.parentElement.classList.add("active");
        customInput.parentElement.classList.remove("active");
      }
    });
  });

  customInput.addEventListener("input", function () {
    radioInputs.forEach((input) => {
      input.checked = false;
      input.parentElement.classList.remove("active");
    });

    // Add the active class to the custom input's parent when it's filled
    customInput.parentElement.classList.add("active");

    // Remove the active class from the custom input's parent if it's empty
    if (this.value === "") {
      radioInputs[0].checked = true;
      radioInputs[0].parentElement.classList.add("active");
      customInput.parentElement.classList.remove("active");
    }
  });
}

// Function to change File input label based on added file
function fileInput() {
  const fileInputs = document.querySelectorAll(".file-upload-d5");

  fileInputs.forEach(function (input) {
    const labelSpan = input.nextElementSibling.nextElementSibling;
    const originalText = labelSpan.textContent;

    input.addEventListener("change", function () {
      if (this.files.length > 0) {
        const fileName = this.files[0].name;
        labelSpan.textContent = fileName;
      } else {
        labelSpan.textContent = originalText;
      }
    });
  });
}

// REMOVED - This function was preventing multiple checkbox selections
// If you need radio button behavior for specific groups, add it back selectively
/*
function checkboxGroup() {
  const allGroups = document.querySelectorAll(".chk-input-container-d5");
  allGroups.forEach((group) => {
    const checkboxes = group.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((box) => {
      box.addEventListener("change", () => {
        if (box.checked) {
          checkboxes.forEach((otherBox) => {
            if (otherBox !== box) {
              otherBox.checked = false;
            }
          });
        }
      });
    });
  });
}
*/

// Step 1 validation
function stepOneValidate(){
  const formContainer = document.querySelector('.step-1-main-d5');
  const nextButton = formContainer.querySelector('.next-btn-d5');
  const inputs = formContainer.querySelectorAll('input[required]');

  nextButton.addEventListener('click', function(event) {
    event.preventDefault();
    let isValid = true;
    inputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false;
        input.classList.add('input-error');
      } else {
        input.classList.remove('input-error');
      }
    });

    if (!isValid) {
      formContainer.classList.add('form-error-d5');
      event.preventDefault();
    } else {
      formContainer.classList.remove('form-error-d5');
    }
  });

  inputs.forEach(input => {
    input.addEventListener('input', () => {
      if (input.value.trim()) {
        input.classList.remove('input-error');
        if (document.querySelectorAll('.input-error').length === 0) {
          formContainer.classList.remove('form-error-d5');
        }
      }
    });
  });
}

function stepTwoValidate() {
  const formContainer = document.querySelector('.mh-step2-main');
  const nextButton = formContainer.querySelector('.next-btn-d5');
  const select = formContainer.querySelector('.select-titles-d5');
  const textInputs = formContainer.querySelectorAll('input[type="text"][required]');
  const fileInputs = formContainer.querySelectorAll('input[type="file"][required]');
  const colorInputs = formContainer.querySelectorAll('.color-input-d5');
  const numberInputs = formContainer.querySelectorAll('input[type="number"][required]');

  nextButton.addEventListener('click', function(event) {
    event.preventDefault();
    let isValid = true;

    // Validate select tag has a value other than the default
    if (select.value === "Titles") {
      isValid = false;
      select.classList.add('input-error');
    } else {
      select.classList.remove('input-error');
    }

    // Validate text inputs
    textInputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false;
        input.classList.add('input-error');
      } else {
        input.classList.remove('input-error');
      }
    });

    // Validate number inputs (e.g., quantity)
    numberInputs.forEach(input => {
      if (!input.value || Number(input.value) < 1) {
        isValid = false;
        input.classList.add('input-error');
      } else {
        input.classList.remove('input-error');
      }
    });

    // Validate file inputs
    fileInputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false;
        input.classList.add('input-error');
      } else {
        input.classList.remove('input-error');
      }
    });

    // Validate each color input (make each required)
    colorInputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false;
        input.parentNode.classList.add('input-error');
      } else {
        input.parentNode.classList.remove('input-error');
      }
    });

    if (!isValid) {
      formContainer.classList.add('form-error-d5');
    } else {
      formContainer.classList.remove('form-error-d5');
    }
  });

  // Clear errors on input
  const allInputs = formContainer.querySelectorAll('input');
  allInputs.forEach(input => {
    input.addEventListener('input', () => {
      if (input.value.trim()) {
        input.classList.remove('input-error');
        if (document.querySelectorAll('.input-error').length === 0) {
          formContainer.classList.remove('form-error-d5');
        }
      }
    });
  });
}

function stepThreeValidate() {
  const formContainer = document.querySelector('.step-3-main-d5');
  const nextButton = formContainer.querySelector('.submit-form-btn-d5');
  const allCheckboxes = formContainer.querySelectorAll('input[type="checkbox"]');
  const textArea = formContainer.querySelector('textarea');

  nextButton.addEventListener('click', function(event) {
    event.preventDefault();
    let isValid = true;

    // Validate that at least ONE checkbox is checked across ALL groups
    const isAnyCheckboxChecked = Array.from(allCheckboxes).some(checkbox => checkbox.checked);
    
    if (!isAnyCheckboxChecked) {
      isValid = false;
      formContainer.querySelector('.chekcboxes-groups-d5').classList.add('input-error');
    } else {
      formContainer.querySelector('.chekcboxes-groups-d5').classList.remove('input-error');
    }

    // Validate textarea is not empty
    if (!textArea.value.trim()) {
      isValid = false;
      textArea.classList.add('input-error');
    } else {
      textArea.classList.remove('input-error');
    }

    if (!isValid) {
      formContainer.classList.add('form-error-d5');
      event.preventDefault(); // Prevent form from submitting if there are errors
    } else {
      formContainer.classList.remove('form-error-d5');
      // Allow form submission
      formContainer.closest('form').submit();
    }
  });

  // Event listener to clear error state when user interacts with inputs
  allCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const isAnyCheckboxChecked = Array.from(allCheckboxes).some(chk => chk.checked);
      if (isAnyCheckboxChecked) {
        formContainer.querySelector('.chekcboxes-groups-d5').classList.remove('input-error');
      }
      // Recheck to remove form error if all validations are now passed
      if (document.querySelectorAll('.input-error').length === 0) {
        formContainer.classList.remove('form-error-d5');
      }
    });
  });

  textArea.addEventListener('input', () => {
    if (textArea.value.trim()) {
      textArea.classList.remove('input-error');
      if (document.querySelectorAll('.input-error').length === 0) {
        formContainer.classList.remove('form-error-d5');
      }
    }
  });
}